<template>
	<div class="user-navbar" v-if='user'>
		<router-link to="/">
			<img src="@/assets/images/common/LogoApp.svg" alt="Asia Actual Logo"/>
		</router-link>
		<p class="site-title"><span class="first-letter">R</span>egistration <span class="first-letter">O</span>ptimized <span class="first-letter">S</span>earch <span class="first-letter">E</span>ngine</p>
		<div class="user-actions">
			<div class="notifications" @click="openNotifications">
				<svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M7.00291 18.0522C8.01829 18.0522 8.84906 17.2215 8.84906 16.2061H5.15675C5.15675 16.6957 5.35126 17.1653 5.69748 17.5115C6.0437 17.8577 6.51328 18.0522 7.00291 18.0522ZM12.5414 12.5138V7.8984C12.5414 5.06455 11.0275 2.69225 8.38752 2.06455V1.43686C8.38752 0.670708 7.76906 0.0522461 7.00291 0.0522461C6.23675 0.0522461 5.61829 0.670708 5.61829 1.43686V2.06455C2.96906 2.69225 1.46444 5.05532 1.46444 7.8984V12.5138L0.273672 13.7046C-0.307867 14.2861 0.0982866 15.283 0.919826 15.283H13.0768C13.8983 15.283 14.3137 14.2861 13.7321 13.7046L12.5414 12.5138Z" fill="#858585"/>
				</svg>
				<div v-if='expiryAlerts.length' class="new-notification-signal"></div>
				<div class="new-notifications-wrapper">
					<div class="new-notifications">
						<div v-if='!expiryAlerts.length' class="notification">No notifications.</div>
						<div v-else class="notification" v-for="notification in expiryAlerts" :key='notification._id'>
							<h6>Registration Expiration</h6>
							<p>{{ notification.registration.productName.trim() }} is set to expire in {{ getMonthsPrior(notification) }} months in {{ getCountryFromSource(notification.registration.source) }}.<br/> Review all Alerts <router-link to='/expiry-alerts'>here</router-link>. </p>
						</div>
					</div>
				</div>
			</div>
			<router-link to="/account" class="my-account">
				<p>My Account</p>
			</router-link>
		</div>
	</div>
</template>

<script>
import * as isUserLoggedIn from '@/store/isUserLoggedIn';
import {axiosClient} from "@/axios-client";
import moment from 'moment';

export default {
	data() {
			return {
					user: isUserLoggedIn.isUserLoggedIn(),
					expiryAlerts: []
			}
	},

	created() {
		axiosClient.get('v1/alerts')
		.then((response) => {
			response.data.forEach(el => {
				let itemDate = moment(el.registration.expirationDate);
				let diff = itemDate.diff(moment(), 'months');

				if(diff <= el.numberOfMonthsPrior && diff >= 0) {
					this.expiryAlerts.push(el);
				}
			});
		})
		// .catch((err) => {console.log(err)});
	},

	methods: {
		openNotifications(e) {
			if(!e.target.closest('.new-notifications')) {
				e.target.closest('.notifications').classList.toggle('active-notifications');
			}
		},

		getCountryFromSource(source) {
      const sourceToCountry = {
        'Singapore HSA': 'Singapore',
        'Philippines FDA': 'Philippines',
        'Thailand FDA': 'Thailand',
        'USFDA': 'United States',
        'Malaysia Medical Device Authority': 'Malaysia',
        'Hong Kong MDD': 'Hong Kong',
        'Indonesia PRKT': 'Indonesia',
      };
      return sourceToCountry[source];
    },

		getMonthsPrior(notification) {
			let itemDate = moment(notification.registration.expirationDate);
			let diff = itemDate.diff(moment(), 'months');
			return diff > 0 ? diff : 'expired';
		}
	}
}
</script>

<style lang="scss">
	.user-navbar {
		padding: 20px 40px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		box-shadow: 0px 4px 15px rgba(51, 51, 51, 0.03);
		border-bottom: 1px solid #F0F0F0;
		position: relative;

		p.site-title {
			margin: 0;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			font-family: "Gotham-Medium";

      span.first-letter {
        font-size: 110%;
        color: #FCAF05;
      }
		}

		.user-actions {
			display: flex;

			.notifications {
				background: #F9F9F9;
				border: 1px solid #E2E2E2;
				border-radius: 5px;
				position: relative;
				width: 45px;
				height: 45px;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-right: 27px;
				cursor: pointer;

				&.active-notifications {
					background: #FCAF05;

					svg path {
						fill: #fff;
					}

					.new-notifications-wrapper {
						z-index: 9999;

						.new-notifications {
							display: block !important;
						}
					}
				}

				.new-notifications-wrapper {
					width: 100%;
					height: 100vh;
					position: fixed;
					top: 0;
					left: 0;
					z-index: -9999;

					.new-notifications {
						max-height: 330px;
						width: 340px;
						background: #fff;
						box-shadow: 0px 8px 20px rgba(51, 51, 51, 0.08);
						border-radius: 15px;
						position: fixed;
						top: 80px;
						right: 2%;
						overflow: scroll;
						display: none;
						border: 1px solid #CDCDCD;

						.notification {
							padding-bottom: 35px;
							border-bottom: 1px solid #ededed;
							padding: 30px 40px;

							&:last-of-type {
								border-bottom: 0;
							}

							h6 {
								font-size: 16px;
								line-height: 26px;
								margin-bottom: 12px;
							}

							p {
								margin: 0;
								font-size: 14px;
								line-height: 22px;
							}

							a {
								color: #FCAF05;
								font-family: "Gotham-Medium";
							}
						}
					}
				}

				.new-notification-signal {
					width: 13px;
					height: 13px;
					background: #FF4A4A;
					transform: translate(50%, -50%);
					border-radius: 100%;
					position: absolute;
					top: 0;
					right: 0;
				}
			}

			.my-account {
				background: #F9F9F9;
				border: 1px solid #E2E2E2;
				border-radius: 5px;
				display: flex;
				justify-content: center;
				align-items: center;
				width: 170px;
				color: #333;

				p {
					margin: 0;
				}
			}
		}
	}
</style>